import { cx } from "@/utils/cx";
import {
  EXPORT_FORMATS,
  type ExportFormat,
} from "../../schemas/tenantDashboard";

/**
 * UC-005 ExportFormatRadioGroup — výběr formátu (XLSX/CSV/JSON) pro David
 * export tlačítko (Phase 23, REQ-BIZ-023).
 *
 * Native `<input type="radio">` v fieldset/legend — accessible by default
 * (vs custom button-group). Touch targets ≥ 48px přes min-h-touch utility
 * na každém option labelu.
 */

const LABELS: Record<ExportFormat, { label: string; helper: string }> = {
  xlsx: {
    label: "XLSX",
    helper: "Excel — vhodné pro účetnictví A&L soft",
  },
  csv: {
    label: "CSV",
    helper: "Plain text — pro import do dalších nástrojů",
  },
  json: {
    label: "JSON",
    helper: "Strukturovaná data — pro vývojářské použití",
  },
};

export interface ExportFormatRadioGroupProps {
  value: ExportFormat;
  onChange: (next: ExportFormat) => void;
  legend?: string;
  name?: string;
}

export function ExportFormatRadioGroup({
  value,
  onChange,
  legend = "Formát exportu",
  name = "export-format",
}: ExportFormatRadioGroupProps) {
  return (
    <fieldset
      className="m-0 flex flex-col gap-2 border-none p-0"
      data-testid="export-format-radio"
    >
      <legend className="mb-1 font-semibold">{legend}</legend>
      {EXPORT_FORMATS.map((opt) => {
        const id = `${name}-${opt}`;
        const isChecked = value === opt;
        return (
          <label
            key={opt}
            htmlFor={id}
            className={cx(
              "flex min-h-touch cursor-pointer items-start gap-2 rounded-xl px-3 py-2 ring-1 ring-secondary",
              isChecked && "bg-secondary ring-brand",
            )}
          >
            <input
              id={id}
              type="radio"
              name={name}
              value={opt}
              checked={isChecked}
              onChange={() => onChange(opt)}
              data-testid={`export-format-${opt}`}
              className="mt-1 h-5 w-5"
            />
            <span className="flex flex-col">
              <strong>{LABELS[opt].label}</strong>
              <span className="text-[0.8125rem] text-tertiary">{LABELS[opt].helper}</span>
            </span>
          </label>
        );
      })}
    </fieldset>
  );
}
